export enum TryRefreshTokenResultEnum {
    Success,
    Expired,
    Failed
}
